import React, { useState, useMemo, useRef, useCallback, useEffect } from 'react';
import { apiHolder as api, apis, } from 'api';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import ReadListIcons from '@web-common/components/UI/Icons/svgs/ReadListSvgs';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import { getShowByFolder } from '@web-mail/common/components/MailMenu/util';
import PrevNextMail from './prev-next-mail';
import { FLOLDER, MAIL_MENU_ITEM, } from '../../common/constant';
import ReadMailIconMenuThreadConfig from '../../common/components/MailMenu/mailMenuConifg/ReadMailIconMenuThreadConfig';
import useReadMailIconMenuConfig from '../../common/components/MailMenu/mailMenuConifg/ReadMailIconMenuConfig';
import MailMenuIcon from '../../common/components/MailMenu/MailMenuIcon/MailMenuIcon';
import { getMailFromMails, shouldSkipOpenNext, } from '../../util';
import useState2RM from '../../hooks/useState2ReduxMock';
import Alert from '@web-common/components/UI/Alert/Alert';
import { MailTabActions, useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { MailTabThunks } from '@web-common/state/reducer/mailTabReducer';
import { getIn18Text } from 'api';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const systemApi = api.api.requireLogicalApi(apis.defaultSystemApiImpl);
const eventApi = api.api.getEventApi();
var MailImportState;
(function (MailImportState) {
    MailImportState["DEFAULT"] = "DEFAULT";
    MailImportState["LOADING"] = "LOADING";
    MailImportState["SUCCESS"] = "SUCCESS";
    MailImportState["FAIL"] = "FAIL";
})(MailImportState || (MailImportState = {}));
const Toobar = ({ listData, content, showMailDiscuss = true, mailList, btnTheme, showMailHead, onShowMailHeadChange }) => {
    const dispatch = useAppDispatch();
    const toobarbox = useRef(null);
    const [, setSelectedMail] = useState2RM('selectedMailId', 'doUpdateSelectedMail');
    const [, setSearchMail] = useState2RM('activeSearchMailId');
    const menuConfig = useReadMailIconMenuConfig(toobarbox.current, content, getShowByFolder(content, [FLOLDER.DRAFT]));
    const [mailMenuItemState, setMailMenuItemState] = useState2RM('mailMenuItemState');
    const [configMailLayout, setConfigMailLayout] = useState2RM('configMailLayout', 'doUpdateConfigMailLayout');
    const isLeftRight = useMemo(() => configMailLayout === '1', [configMailLayout]);
    const isUpDown = useMemo(() => configMailLayout === '3', [configMailLayout]);
    const isMainPage = systemApi.isMainPage();
    const shouldShowPrevNextMail = !isLeftRight && !isUpDown && isMainPage && (content === null || content === void 0 ? void 0 : content.mailFrom) !== 'subordinate';
    const domPropsRender = useCallback((mails, menuConfig) => {
        return {
            'data-test-id': 'mail-menu-toobar-' + (menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.key),
        };
    }, []);
    const menuCustomConfig = useMemo(() => [
        {
            key: MAIL_MENU_ITEM.BACK,
            show: (mail, defaultShow) => {
                if (isLeftRight || isUpDown) {
                    return false;
                }
                return !!defaultShow ? defaultShow(mail) : false;
            },
        },
        {
            key: MAIL_MENU_ITEM.MAIL_WITHDRAW,
            show: (mail, defaultShow) => {
                if (listData === null || listData === void 0 ? void 0 : listData.isrcl) {
                    return false;
                }
                return !!defaultShow ? defaultShow(mail) : false;
            },
        },
        {
            key: MAIL_MENU_ITEM.MAIL_WITHDRAW_RES,
            show: (mail, defaultShow) => !!(listData === null || listData === void 0 ? void 0 : listData.isrcl) && (defaultShow ? defaultShow(mail) : false),
            onClick: mails => {
                const mail = getMailFromMails(mails);
                if (listData === null || listData === void 0 ? void 0 : listData.isrcl) {
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: { mailData: mail, showRes: true },
                        eventStrData: 'retractEmail',
                        _account: mail === null || mail === void 0 ? void 0 : mail._account,
                    });
                }
            },
        },
        {
            key: MAIL_MENU_ITEM.SHARE,
            show: (mail, defaultShow) => {
                if (showMailDiscuss) {
                    if (defaultShow) {
                        return defaultShow(mail);
                    }
                    return true;
                }
                return false;
            },
        },
        {
            key: MAIL_MENU_ITEM.DELETE,
            onClick: (mails, defaultClick) => {
                const mail = getMailFromMails(mails);
                if ((mail === null || mail === void 0 ? void 0 : mail.isThread) && mailList && (mailList === null || mailList === void 0 ? void 0 : mailList.length) > 1) {
                    Alert.error({
                        title: getIn18Text('SHIFOUSHANCHUQUANYOUJIAN'),
                        content: null,
                        okCancel: !0,
                        cancelText: getIn18Text('QUXIAO'),
                        okText: getIn18Text('SHANCHU'),
                        onOk: () => {
                            defaultClick && defaultClick(mail);
                        },
                        okButtonProps: {
                            style: {
                                backgroundColor: '#FE5B4C',
                            },
                        },
                    });
                }
                else {
                    defaultClick && defaultClick(mail);
                }
            },
        },
        {
            key: MAIL_MENU_ITEM.EMAIL_HEADER,
            name: mail => {
                return showMailHead ? getIn18Text('CHAKANYOUJIAN') : getIn18Text('CHAKANXINTOU');
            },
            onClick: mails => {
                if (onShowMailHeadChange) {
                    onShowMailHeadChange(!showMailHead);
                    console.log('EMAIL_HEADER');
                }
            },
        },
    ], [listData, showMailDiscuss, isLeftRight, isUpDown, mailList, showMailHead, onShowMailHeadChange]);
    const [mailImportState, setMailImportState] = useState(MailImportState.DEFAULT);
    const doLocalMailImport = (cid) => {
        if (typeof cid === 'string') {
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: { cid },
                eventStrData: 'importMail',
            });
        }
        setMailImportState(MailImportState.DEFAULT);
    };
    const ckImport = (mail) => {
        const isLoading = mailImportState == MailImportState.LOADING;
        const { entry } = content;
        const { content: domCont, attachment: attachments } = entry;
        const { contentLen } = domCont;
        const totalSize = (attachments || []).reduce((total, curAtt) => {
            const { type, fileSize } = curAtt;
            return total + (type === 'netfolder' ? 0 : fileSize || 0);
        }, contentLen || 0);
        if (totalSize / (1024 * 1024) > 100) {
            SiriusMessage.warn({ content: getIn18Text('YOUJIANDAORUBUYUNXU') });
            return;
        }
        if (mail.localFilePath && mail.cid && !isLoading) {
            setMailImportState(MailImportState.LOADING);
            doLocalMailImport(mail.cid);
        }
    };
    const emlMenuCustomConfig = useMemo(() => [
        {
            key: MAIL_MENU_ITEM.LOCAL_MAIL_IMPORT,
            name: getIn18Text('YOUJIANDAORU'),
            show: mails => {
                const mail = getMailFromMails(mails);
                return !!(mail === null || mail === void 0 ? void 0 : mail.localFilePath);
            },
            tooltip: '',
            icon: React.createElement(ReadListIcons.MoveSvg_Cof, null),
            render: mails => {
                const mail = getMailFromMails(mails);
                const isLoading = mailImportState == MailImportState.LOADING;
                return (React.createElement("div", { className: "mail-import-btn", onClick: () => ckImport(mail) },
                    React.createElement("div", { className: "btn-icon dark-svg-invert" }, isLoading ? React.createElement(LoadingOutlined, null) : React.createElement(ReadListIcons.MoveSvg_Cof, null)),
                    React.createElement("div", { className: "btn-name" }, getIn18Text('YOUJIANDAORU'))));
            },
        },
    ], [mailImportState]);
    const handelIconMenuBeforeClick = useCallback((config, data) => {
        let name = config === null || config === void 0 ? void 0 : config.name;
        if (typeof (config === null || config === void 0 ? void 0 : config.name) === 'function') {
            const _name = config === null || config === void 0 ? void 0 : config.name(data);
            if (typeof _name === 'string') {
                name = _name;
            }
        }
        trackApi.track('pcMail_click_topBarButton_mailDetailPage', { buttonName: name });
    }, []);
    const MailMenuIconElement = useMemo(() => {
        const { isThread, localFilePath } = content;
        const defaultMenu = localFilePath ? emlMenuCustomConfig : isThread ? ReadMailIconMenuThreadConfig : menuConfig;
        const customMenu = localFilePath ? [] : menuCustomConfig;
        return (React.createElement(MailMenuIcon, { mail: content, menu: customMenu, domProps: domPropsRender, defaultMenu: defaultMenu, menuType: "text", menuItemStateMap: mailMenuItemState, theme: btnTheme, onMenuItemStateChange: (menuId, data) => {
                var _a, _b;
                return setMailMenuItemState(Object.assign(Object.assign({}, mailMenuItemState), { [(_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.id]: Object.assign(Object.assign({}, (mailMenuItemState[(_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.id] || {})), { [menuId]: data }) }));
            }, beforeMenuItemClick: handelIconMenuBeforeClick }));
    }, [content, menuCustomConfig, emlMenuCustomConfig, menuConfig, mailMenuItemState, btnTheme]);
    const [prevNextMailInfo, setPrevNextMailInfo] = useState({
        prevMid: undefined,
        nextMid: undefined,
        prevMidTitle: '',
        nextMidTitle: '',
    });
    const currentTab = useAppSelector(state => state.mailTabReducer.currentTab);
    const currentTabId = useAppSelector(state => state.mailTabReducer.currentTab.id);
    const [mailSearching] = useState2RM('mailSearching', 'doUpdateMailSearching');
    useMsgRenderCallback('mailStoreRefresh', ev => {
        var _a, _b, _c;
        if (!isMainPage || isLeftRight)
            return;
        if (currentTab.type !== 'read')
            return;
        if (ev && ev.eventData && ev.eventStrData === 'mailOp' && ev.eventData.opType === 'delete') {
            const eventData = ev.eventData;
            if (eventData.status === 'success') {
                const mailIds = Array.isArray(eventData.params.id) ? eventData.params.id : [eventData.params.id];
                if (configMailLayout === '2' && shouldSkipOpenNext((_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.folder)) {
                    if (mailIds && mailIds.length === 1) {
                        const currentMid = ((_b = currentTab.extra) === null || _b === void 0 ? void 0 : _b.originMid) || content.entry.id;
                        if (currentMid === mailIds[0]) {
                            dispatch(MailTabActions.doCloseTab(currentTab.id));
                            return;
                        }
                    }
                }
                if (!prevNextMailInfo.nextMid) {
                    dispatch(MailTabActions.doCloseTab(currentTab.id));
                    return;
                }
                if (mailIds && mailIds.length === 1) {
                    const currentMid = ((_c = currentTab.extra) === null || _c === void 0 ? void 0 : _c.originMid) || content.entry.id;
                    if (currentMid === mailIds[0]) {
                        handleOnNextMail();
                    }
                }
            }
        }
    });
    useMsgRenderCallback('mailMenuOper', ev => {
        const { eventStrData } = ev;
        if (eventStrData === 'OnNextMail') {
            handleOnNextMail();
        }
        else if (eventStrData === 'OnPrevMail') {
            handleOnPrevMail();
        }
    });
    useEffect(() => {
        var _a;
        const mid = ((_a = currentTab.extra) === null || _a === void 0 ? void 0 : _a.originMid) || content.entry.id;
        updatePrevNextMailInfo(mid, 0);
    }, [currentTabId]);
    const updateCurrentTabInfo = (mid, title) => {
        dispatch(MailTabActions.doUpdateCurrentTab(Object.assign(Object.assign({}, currentTab), { title: title, extra: Object.assign(Object.assign({}, currentTab.extra), { originMid: mid }) })));
    };
    const updatePrevNextMailInfo = async (mid, offset) => {
        const midWithTs = currentTabId;
        dispatch(MailTabThunks.getCurrentReadMail({ originTabId: midWithTs, currentMid: mid, offset })).then((r1) => {
            var _a, _b;
            let prevMailInfo, nextMailInfo;
            prevMailInfo = (_a = r1.payload) === null || _a === void 0 ? void 0 : _a.prevMail;
            nextMailInfo = (_b = r1.payload) === null || _b === void 0 ? void 0 : _b.nextMail;
            setPrevNextMailInfo(() => {
                return {
                    prevMid: prevMailInfo ? prevMailInfo.mid : '',
                    nextMid: nextMailInfo ? nextMailInfo.mid : '',
                    prevMidTitle: prevMailInfo ? prevMailInfo.title : '',
                    nextMidTitle: nextMailInfo ? nextMailInfo.title : '',
                };
            });
        });
    };
    const handleOnPrevMail = () => {
        const prevMid = prevNextMailInfo.prevMid;
        if (prevMid) {
            updateCurrentTabInfo(prevMid, prevNextMailInfo.prevMidTitle);
            if (mailSearching) {
                setSearchMail({ id: prevMid });
            }
            else {
                setSelectedMail({ id: prevMid });
            }
            updatePrevNextMailInfo(prevMid, -1);
        }
    };
    const handleOnNextMail = () => {
        const nextMid = prevNextMailInfo.nextMid;
        if (nextMid) {
            updateCurrentTabInfo(nextMid, prevNextMailInfo.nextMidTitle);
            if (mailSearching) {
                setSearchMail({ id: nextMid });
            }
            else {
                setSelectedMail({ id: nextMid });
            }
            updatePrevNextMailInfo(nextMid, 1);
        }
    };
    return useMemo(() => (React.createElement("div", { className: "toobar-wrap ant-allow-dark", style: { flex: '0 0 auto' } },
        React.createElement("div", { className: "toobar-left", ref: toobarbox }, MailMenuIconElement),
        React.createElement("div", { className: "toobar-right" }, shouldShowPrevNextMail && (React.createElement(PrevNextMail, { bgColor: content && content.isThread ? '#fff' : '', onNext: () => {
                handleOnNextMail();
            }, onPrev: () => {
                handleOnPrevMail();
            }, prevDisable: !prevNextMailInfo.prevMid, nextDisable: !prevNextMailInfo.nextMid, prevTitle: prevNextMailInfo.prevMidTitle, nextTitle: prevNextMailInfo.nextMidTitle }))))), [content, MailMenuIconElement]);
};
export default Toobar;
